import React, { useState, useEffect, Fragment } from "react";

import { observer } from "mobx-react-lite";
import { makeStyles } from "@mui/styles";
import { useStores } from "../../../core/stores/index";
import "./WorkflowList.css";
import { MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { WorkflowType } from "common/enums/WorkflowType";
import { IWorkflow } from "common/interfaces/IWorkflow";
import "react-data-grid/lib/styles.css";

import ReactDataGrid, { Column } from "react-data-grid";
import { Spinner } from "components/common/Spinner";

interface WorkflowListProp {
    children: JSX.Element;
}

export const WorkflowList = observer((props: WorkflowListProp) => {
    const navigate = useNavigate();

    const { userStore, workflowStore } = useStores();

    const snackbar = useSnackbar();
    const [showLoader, setShowLoader] = useState<boolean | undefined>(undefined);

    const [workflows, setWorkflows] = useState<IWorkflow[]>([]);

    useEffect(() => {
        if (workflowStore.isWorkflowOperation) {
            snackbar.enqueueSnackbar(workflowStore.workflowOperationMessage, {
                variant: workflowStore.messageVariant,
            });

            workflowStore.clearUserOperationFlags();
        }
    }, []);

    useEffect(() => {
        setShowLoader(true);
        workflowStore.getAllWorkflows().then((response) => {
            setWorkflows(response.workflows);
            setShowLoader(false);
        });
        userStore.getAllUsers().then((response)=>{});
    }, []);

    const newWorkflowHandler = () => {
        workflowStore.resetSelectedWorkflow();
        navigate("/addworkflow");
    };

    const workflowClickHandler = async (workflowId: any, name: any, type: any) => {
        await workflowStore.getWorkflowById(workflowId);
        navigate(`/newworkflow/${name}/${type}`);
    };

    const getColumns = () => {
        const columns = [
            {
                key: "name",
                name: "Name",
                renderCell: (params: any) => (
                    <a className="hyperink" href="#" onClick={() => workflowClickHandler(params.row.workflowId, params.row.name, params.row.workflowType)}>
                        {params.row.name}
                    </a>
                ),
            },
            {
                key: "type",
                name: "Type",
                renderCell: (params: any) => <div>{WorkflowType[params.row.workflowType]}</div>,
            },
            {
                key: "investigator",
                name: "Investigator",
                renderCell: (params: any) => <div>{params.row.level2Investigator.name}</div>,
            },
        ];

        return columns;
    };

    return (
        <div className="container-fluid p-1">
            <div className="m-4 card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-6 align-content-center">
                            <h1>Workflows</h1>
                        </div>
                        <div className="col-6 p-2">
                            <div className="align-button-end">
                                <button className="btn btn-primary float-right" onClick={newWorkflowHandler} title="Add Workflow">
                                    {"Add Workflow"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6 my-2 my-lg-0 align-content-center"></div>
                <div className="row card-body w-100 h-100">
                    <div className="col table-responsive p-2 grid-parent-container">
                        {workflows.length > 0 && getColumns().length > 0 && (
                            <ReactDataGrid className="grid-child-container" columns={getColumns()} rows={workflows} />
                        )}
                        {showLoader && <Spinner />}
                    </div>
                </div>
            </div>
        </div>
    );
});
